:host {
  display: block;

  .top-100 {top: 100%}
  .bottom-100 {bottom: 100%}
}

.nest-date-picker {
  @apply relative flex flex-col relative;

  &__label {
    @apply mb-1 mt-2 text-foreground;
  }

  &__control {
    @apply max-w-[300px] my-1 bg-background px-2 py-1 flex border border-input rounded cursor-pointer;
  }
}

.datepicker-month {
  &__item {
    @apply block flex-1 leading-9 rounded-full text-center text-sm;
  }
}

.datepicker-years {
  @apply grid grid-cols-3 gap-2;

  &__item {
    @apply block flex-1 leading-9 border rounded-xl hover:cursor-pointer text-center text-gray-900 dark:text-white font-semibold text-sm;
  }
}

.nest-date-picker-day {

  button {
    @apply m-px size-10 flex justify-center items-center border border-transparent text-sm text-gray-800
    hover:border-blue-600 hover:text-blue-600 rounded-full disabled:text-gray-300 disabled:pointer-events-none;
  }

  &--selected {
    @apply bg-blue-600 rounded-full;

    button {
      @apply text-white hover:text-white;
    }
  }
}


.nest-date-picker-item__button {

  @apply block flex-1 leading-9 rounded-full flex justify-center items-center border border-transparent text-sm text-gray-800
  hover:border-blue-600 hover:text-blue-600 disabled:text-foreground/5 disabled:pointer-events-none;
}

